import ErrorTemplate from "../../components/error-template";
import { Link } from "@acesso-io/genoma-ui";
import { useTranslation } from '@frontend/feature-i18n';
import PropTypes from 'prop-types';

const DEFAULT_HELP_URL = "https://empresas.unico.io/hc/pt-br";

const Error5xx = ({ helpUrl = DEFAULT_HELP_URL }) => {
  const { getTranslation, getTranslationAsString } = useTranslation();

  return (
    <ErrorTemplate
      errorCode='5xx'
      title={getTranslationAsString('SystemMisbehaved', {}, 'Nosso sistema não se comportou como deveria')}
    >
      <span>
        {getTranslation(
          "ContactSupport",
          null,
          {
            Link: <Link href={helpUrl} target="_blank" rel="noreferrer noopener" />,
          },
          "Pedimos desculpa pelo transtorno, por favor <Link>entre em contato com nossa equipe de suporte.</Link>"
        )}
      </span>
    </ErrorTemplate>
  );
};

Error5xx.propTypes = {
  helpUrl: PropTypes.string,
};

export default Error5xx;
